import { Injectable } from '@angular/core';
import { MemberAdRequest } from './DTOs/member-ad-request';
import { ApiClient } from '../core/api-client.service';
import {GetMemberAdsListRequest} from "./DTOs/get-member-ad-list-request";
import {Observable} from "rxjs";
import {MemberAdsDtRetInfo} from "./DTOs/member-ad-dt-ret-info";
import {MemberAd} from "./DTOs/member-ad";
import {AdUpdateRequest} from "./DTOs/ad-update-request";
import {VerifyRejectRequest} from "../core/verify-reject-request";
import { AdType } from './DTOs/AdTypes';

@Injectable({
  providedIn: 'root'
})
export class MemberAdService {
    readonly relativeBase = "member-ads/";

    constructor(private http: ApiClient) { }


    uploadAdFile(uploadData: FormData) {
        return this.http.post(this.relativeBase + "upload", uploadData);
    }
    submitMemberAd(req: MemberAdRequest) {
        return this.http.post(this.relativeBase + "member-submit", req);
    }
    updateMemberAd(req: AdUpdateRequest) {
        return this.http.post(this.relativeBase + "update", req);
    }
    getPendingAdList(req: GetMemberAdsListRequest): Observable<MemberAdsDtRetInfo> {
        return this.http.post(this.relativeBase + "get-pending-ads", req);
    }
    getPreviousAdList(req: GetMemberAdsListRequest): Observable<MemberAdsDtRetInfo> {
        return this.http.post(this.relativeBase + "get-previous-ads", req);
    }
    getPendingAd(adId: number): Observable<MemberAd> {
        return this.http.get(this.relativeBase + "details/" + adId);
    }
    changeAdStatus(request: VerifyRejectRequest, status: number) {
        if(status == 1)
            return this.http.post(this.relativeBase + "approve", request);
        else
            return this.http.post(this.relativeBase + "reject", request);
    }
    getAdTypeOptions(): Observable<AdType[]> {
        return this.http.get(this.relativeBase + "get-ad-types");
    }
    getAdTypeDetails(adType: number): Observable<AdType> {
        return this.http.get(this.relativeBase + "ad-type-details/" + adType);
    }
    getMembershipLevel(): Observable<string> {
        return this.http.get(this.relativeBase + "get-membership-level");
    }
    getAdImageUrl(adId: number): Observable<string> {
        return this.http.get(this.relativeBase + "get-image-url/" + adId);
    }
    sendUpgradeInterest() {
        return this.http.post(this.relativeBase + "send-upgrade-interest", null);
    }
}
